import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, MapPinIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <header className="relative isolate w-full overflow-hidden bg-abyss" data-id="element-45" data-mp="ei1zbx8twn38">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/87dd5680-0bb1-4bcd-8cf4-38d1de0d17bf.jpg" alt="Pescador mexicano sosteniendo una lobina trofeo al amanecer en una presa" className="absolute inset-0 h-full w-full object-cover object-center opacity-55" data-id="element-46" data-mp="9l32v81p041v" />
      <div className="absolute inset-0 bg-abyss/70" aria-hidden="true" data-id="element-47" data-mp="x8b85pz4fd3w" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-abyss to-transparent" aria-hidden="true" data-id="element-48" data-mp="s9zwrat6gujk" />

      <div className="relative mx-auto flex min-h-[62vh] max-w-6xl flex-col justify-end px-4 pb-8 pt-14 sm:min-h-[80vh] sm:px-8 sm:pb-20 sm:pt-24" data-id="element-49" data-mp="3d1ildbzsjgoh">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-50" data-mp="381nuh8g0mr3f">
          <div className="mb-3 flex flex-wrap items-center gap-x-3 gap-y-1 font-cond text-[0.68rem] uppercase tracking-[0.16em] text-chartreuse sm:mb-6 sm:text-sm sm:tracking-[0.2em]" data-id="element-51" data-mp="3o7vkflb27pxt">
            <span className="flex items-center gap-1.5" data-id="element-52" data-mp="3e963buqzm9im">
              <MapPinIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-53" data-mp="3e7l802wummjp" />
              Hecho a mano en México
            </span>
            <span className="hidden h-4 w-px bg-bone/30 sm:block" aria-hidden="true" data-id="element-54" data-mp="358hoixtrs54o" />
            <span className="text-bone/70" data-id="element-55" data-mp="2qjv9yybyvhei">El Salto · Comedero · Aguamilpa</span>
          </div>

          <h1 className="font-display text-[1.9rem] uppercase leading-[0.95] text-bone sm:text-6xl sm:leading-[0.92] lg:text-[5rem]" data-id="element-56" data-mp="2viy3blil3z6n">
            La lobina de tu vida no está esperando
            <span className="block text-chartreuse" data-id="element-57" data-mp="2hlj7nz1qmv68">
              otro pedazo de plástico muerto.
            </span>
          </h1>

          <p className="mt-4 max-w-2xl font-body text-[0.95rem] leading-relaxed text-bone/80 sm:mt-6 sm:text-xl" data-id="element-58" data-mp="s2jnvz2aw4kk">
            Polímero de alta memoria para que la cola nunca deje de vibrar,
            aroma amasado dentro de la mezcla y colores moldeados a mano en
            México. Movimiento que se siente antes de verse.
          </p>

          <div className="mt-5 flex flex-col items-stretch gap-2.5 sm:mt-9 sm:flex-row sm:items-center sm:gap-4" data-id="element-59" data-mp="deq40266mfw6">
            <CtaButton size="md" source="hero" className="sm:hidden" data-id="element-60" data-mp="1ayt7t2zvvpch">
              ¡Quiero pescar más ya!
            </CtaButton>
            <CtaButton source="hero" className="hidden sm:inline-flex" data-id="element-61" data-mp="112g5jgq9w364">
              ¡Quiero pescar más ya!
            </CtaButton>
            <span className="flex items-center gap-2 font-cond text-[0.8rem] uppercase tracking-wider text-bone/65 sm:text-base" data-id="element-62" data-mp="x0crckc7ykh5">
              <FlameIcon className="h-4 w-4 text-blood sm:h-5 sm:w-5" aria-hidden="true" data-id="element-63" data-mp="3lque9na2654j" />
              Pack Pro-Series · 30 piezas · $399
            </span>
          </div>
        </motion.div>
      </div>
    </header>;
}